import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client';
import { PRODUCT_AVAILABLE_SIZES } from '../queries';
import usePDPApolloQueryVariables from '../usePDPApolloQueryVariables';
const useProductAvailableSizes = (id, slug) => {
  const $ = _c(9);
  const {
    variables,
    skip
  } = usePDPApolloQueryVariables(id, slug);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      noBatch: true
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== skip || $[2] !== variables) {
    t1 = {
      variables,
      skip,
      context: t0
    };
    $[1] = skip;
    $[2] = variables;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    loading,
    error,
    data,
    refetch
  } = useQuery(PRODUCT_AVAILABLE_SIZES, t1);
  const t2 = loading || skip;
  const t3 = data?.availableSizes;
  let t4;
  if ($[4] !== error || $[5] !== refetch || $[6] !== t2 || $[7] !== t3) {
    t4 = {
      loading: t2,
      error,
      data: t3,
      refetch
    };
    $[4] = error;
    $[5] = refetch;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export default useProductAvailableSizes;